import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function SplunkCloudConnectForm({ onSubmit, guideMode }) {
  const [showAPIToken, setShowAPIToken] = useState(false);
  const handleClickShowAPI = () => setShowAPIToken(!showAPIToken);
  const handleMouseDownAPI = () => setShowAPIToken(!showAPIToken);

  const formInitialValues = {
    apiToken: "",
    tokenIndex: "",
    webhookURL: "",
    port: "",
  };
  const formCheckoutSchema = yup.object().shape({
    apiToken: yup.string().required("required"),
    webhookURL: yup.string().required("required"),
    port: yup.number().typeError("Port must be a number"),
  });

  const trimWebhookURL = (url) => {
    const index = url.indexOf(".com");
    return index !== -1 ? url.substring(0, index + 4) : url;
  };

  const handleFormSubmit = (values) => {
    const trimmedValues = {
      ...values,
      webhookURL: trimWebhookURL(values.webhookURL),
    };
    onSubmit(trimmedValues);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                type={showAPIToken ? "text" : "password"}
                name="apiToken"
                autoComplete="off"
                label="API Token Value"
                value={values.apiToken}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.apiToken && !!errors.apiToken}
                helperText={touched.apiToken && errors.apiToken}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle key visibility"
                        onClick={handleClickShowAPI}
                        onMouseDown={handleMouseDownAPI}
                      >
                        {showAPIToken ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="tokenIndex"
                label="Default Index - leave blank if index main is selected"
                value={values.tokenIndex}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.tokenIndex && !!errors.tokenIndex}
                helperText={touched.tokenIndex && errors.tokenIndex}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="webhookURL"
                label="Splunk Cloud URL"
                value={values.webhookURL}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.webhookURL && !!errors.webhookURL}
                helperText={touched.webhookURL && errors.webhookURL}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="port"
                label="HTTP Port Number (leave blank if 443)"
                value={values.port}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.port && !!errors.port}
                helperText={touched.port && errors.port}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
